<template>

<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header">
				<h1>{{ $t($route.name) }}</h1>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid">

	<div class="row">
		<div class="col-md-12">
				<div class="card">
						<form method="get" action="/" class="form-horizontal">
								<div class="card-block">
										<div class="row">
											<iframe src="https://calendar.google.com/calendar/htmlembed?src=%23contacts%40group.v.calendar.google.com&ctz=Europe/Sofia" style="border: 0" width="100%" height="600" frameborder="0" scrolling="no"></iframe>
										</div>
								</div>
						</form>
				</div>
		</div>
	</div>
</div>
</div>

</template>

<script>

module.exports = {
	data: function () {
		return {
			generateRandomNumbers: function (numbers, max, min) {
				var a = [];
				for (var i = 0; i < numbers; i++) {
					a.push(Math.floor(Math.random() * (max - min + 1)) + max);
				}
				return a;
			}
		};
	},
	computed: {
		coPilotNumbers: function () {
			return this.generateRandomNumbers(12, 1000000, 10000);
		},
		personalNumbers: function () {
			return this.generateRandomNumbers(12, 1000000, 10000);
		},
		isMobile: function () {
			return (window.innerWidth <= 800 && window.innerHeight <= 600);
		}
	}
};
</script>
<style>
.info-box {
	cursor: pointer;
}
.info-box-content {
	text-align: center;
	vertical-align: middle;
	display: inherit;
}
.fullCanvas {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// Calendar.vue?5b6458de